import { Skeleton } from "./skeleton";

interface TableSkeletonProps {
  columns?: number;
  rows?: number;
  showHeader?: boolean;
}

export function TableSkeleton({ 
  columns = 4, 
  rows = 5, 
  showHeader = true 
}: TableSkeletonProps) {
  return (
    <div className="w-full overflow-auto">
      <div className="min-w-full divide-y divide-border rounded-md border">
        {showHeader && (
          <div className="grid grid-cols-1 gap-4 bg-muted/50 p-4 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6">
            {Array(columns)
              .fill(null)
              .map((_, i) => (
                <Skeleton key={i} className="h-6 w-full" />
              ))}
          </div>
        )}
        <div className="divide-y divide-border">
          {Array(rows)
            .fill(null)
            .map((_, rowIndex) => (
              <div 
                key={rowIndex} 
                className="grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6"
              >
                {Array(columns)
                  .fill(null)
                  .map((_, colIndex) => (
                    <Skeleton key={colIndex} className="h-6 w-full" />
                  ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
} 